/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/football/match/area': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M22.256 5.24H2.906a.744.744 0 00-.744.745v8.93c0 .412.334.745.744.745h19.35c.41 0 .744-.333.744-.745v-8.93a.744.744 0 00-.744-.744zm-.744 8.931H3.65V6.73h17.862v7.442z" _fill="#1F2532"/><path pid="1" d="M17.79 5.24H7.373a.744.744 0 00-.745.745v4.465c0 .412.334.744.745.744H17.79c.41 0 .744-.332.744-.744V5.985a.744.744 0 00-.744-.744zm-.744 4.466h-8.93V6.729h8.93v2.977zM17.79 14.171H7.373a.744.744 0 00-.745.744c0 2.872 2.671 5.21 5.954 5.21s5.954-2.338 5.954-5.21a.744.744 0 00-.744-.744zm-5.209 4.466c-2.156 0-3.96-1.281-4.375-2.977h8.75c-.414 1.696-2.219 2.977-4.375 2.977z" _fill="#1F2532"/>'
  }
})
